module.exports = __webpack_public_path__ + "static/parade-2019-house19-199abf97977f9cd43391f14c8e268fc4.jpg";